export const generateUniqueNodeLabel = (
    baseLabel: string,
    existingLabels: string[],
): string => {
    if (!existingLabels.includes(baseLabel)) {
        return baseLabel;
    }

    let counter = 1;
    let uniqueLabel: string;

    do {
        const paddedNumber = String(counter).padStart(2, '0');
        uniqueLabel = `${baseLabel} ${paddedNumber}`;
        counter++;
    } while (existingLabels.includes(uniqueLabel));

    return uniqueLabel;
};

export const getUniqueLabelForNodeType = (
    nodes: any[],
    baseLabel: string,
    nodeType: string,
): string => {
    const nodesOfSameType = nodes.filter(node => node.type === nodeType);

    if (nodesOfSameType.length === 0) {
        return baseLabel;
    }

    const existingLabels = nodesOfSameType.map(node => node.data?.label).filter(Boolean);
    return generateUniqueNodeLabel(baseLabel, existingLabels);
};

